export const API_URL = 'https://virtserver.swaggerhub.com/devnow/Kind/1.0.0';


// WEBPACK FOOTER //
// ./src/api/config/config.js